<template>
  <div id="visadoparcelario-tramites-new-or-edit">
    <LmComponentLoading v-if="loading" fixed />
    <LmFormBuilder
      ref="lmFormBuilder"
      :endpointUriwhereGetComponents="`formbuilder/${idFormBuilder}`"
      :endpointUriWhereGetValuesToLoadInEditMode="$route.params.id && `visadoparcelario/${$route.params.id}`"
      @formObjectToSendToServerChange="updateForm($event)"
      />
    <portal to="destination-after-title">
      <div class="container-fluid">
        <b-row v-if="vecinoIsLoading" class="mt-5">
          <b-col cols="4"><b-skeleton type="input"></b-skeleton></b-col>
          <b-col cols="4"><b-skeleton type="input"></b-skeleton></b-col>
          <b-col cols="4"><b-skeleton type="input"></b-skeleton></b-col>
        </b-row>
        <div v-else class="row">
          <LmTextInput
            class="col-4"
            v-model="vecino.NumeroDocumento"
            label="Documento"
            :disabled="true"
          />
          <LmTextInput
            class="col-4"
            v-model="vecino.Nombre"
            label="Nombre"
            :disabled="true"
          />
          <LmTextInput
            class="col-4"
            v-model="vecino.Apellido"
            label="Apellido"
            :disabled="true"
          />
        </div>
      </div>
    </portal>
    <portal to="destination-10">
      <div class="container-fluid">
        <b-row v-if="propietarioIsLoading" class="mt-5">
          <b-col cols="4"><b-skeleton type="input"></b-skeleton></b-col>
          <b-col cols="4"><b-skeleton type="input"></b-skeleton></b-col>
          <b-col cols="4"><b-skeleton type="input"></b-skeleton></b-col>
        </b-row>
        <div v-else class="row">
          <LmFormSubtitles
            class="col-12"
            text="Datos del Propietario"
          />
          <LmSuperPowerSelectV2
            class="col-3"
            urlPathFromGetOptions="/crm/tipodocumento"
            label="Tipo de Documento"
            :defaultValue="form.PropietarioTipoDocumento"
            v-model="form.PropietarioTipoDocumento"
          />
          <LmNumberInputGroup
            class="col-9 search-prop-doc"
            v-model="searchPropietarioNumeroDocumento"
            :v="$v.form.numeroDocumento"
            label="Documento"
            placeholder="Solo números"
            :buttonName="$t('search')"
            @click="search"
            :disabled="disableSearch"
            :isProcessing="propietarioIsLoading"
            />
          <LmTextInput
            class="col-4"
            v-model="propietario.NumeroDocumento"
            label="Documento"
            :disabled="true"
          />
          <LmTextInput
            class="col-4"
            v-model="propietario.Nombre"
            label="Nombre"
            :disabled="true"
          />
          <LmTextInput
            class="col-4"
            v-model="propietario.Apellido"
            label="Apellido"
            :disabled="true"
          />
          <LmFormSeparator
            class="col-12"
          />
        </div>
      </div>
    </portal>
    <portal to="destination-14">
      <div class="container-fluid">
          <LmUploadFiles
            :dropzoneOptions="dropzoneOptions"
            v-on:vdropzone-removed-file="fileRemoved"
            v-on:vdropzone-success="fileCreated"
          />
      </div>
    </portal>
    <portal to="button-submit">
      <LmButton
        id="boton-crear"
        :value="(isOnEditMode)? 'Guardar' : 'Crear'"
        type="submit"
        buttonClass="btn-primary"
        @click.native="submit"
        />
    </portal>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import commonsApi from '@/api/commons'
import LmFormBuilder from '@/components/LmFormBuilder'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmButton from '@/components/form/elements/LmButton'
import lmFormMixinV2 from '@/mixins/lmFormMixinV2.js'
import lmToasts from '@/mixins/lmToasts.js'
import LmUploadFiles from '@/components/LmUploadFiles'
import LmNumberInputGroup from '@/components/form/elements/LmNumberInputGroup'
import LmSuperPowerSelectV2 from '@/components/form/elements/LmSuperPowerSelectV2.vue'
import LmFormSeparator from '@/components/form/elements/LmFormSeparator'
import LmFormSubtitles from '@/components/form/elements/LmFormSubtitles'

export default {
  mixins: [lmFormMixinV2, lmToasts],
  components: {
    LmUploadFiles,
    LmFormBuilder,
    LmTextInput,
    LmButton,
    LmNumberInputGroup,
    LmSuperPowerSelectV2,
    LmFormSeparator,
    LmFormSubtitles
  },
  data () {
    return {
      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_URL}documentos/nuevo/?id=${this.$route.params.id}`,
        headers: {
          'Cache-Control': null,
          'X-Requested-With': null
        },
        withCredentials: true,
        thumbnailWidth: 150,
        maxFilesize: 50,
        timeout: 120000,
        addRemoveLinks: true
      },
      vecinoIsLoading: true,
      propietarioIsLoading: false,
      form: {
        NumeroDocumento: null,
        PropietarioTipoDocumento: {},
        TipoSolicitante: {},
        PropietarioNumeroDocumento: null
      },
      propietario: {},
      formIsProcessing: false,
      initialForm: {}
    }
  },
  props: {
    idFormBuilder: {
      type: String,
      required: true
    },
    newOrEditEndpointUri: {
      type: String,
      required: true
    },
    vecinoEndpointUri: {
      type: String,
      required: true
    }
  },
  computed: {
    disableSearch () {
      return !this.form.PropietarioTipoDocumento?.id
    },
    showPropietario () {
      return this.form.TipoSolicitante.id !== '1'
    }
  },
  validations: {
    form: {
      NumeroDocumento: {
        required
      }
    }
  },
  watch: {
    'form.PropietarioTipoDocumento' () {
      this.form.PropietarioNumeroDocumento = null
    }
  },
  methods: {
    async submit () {
      const lmFormBuilderValidations = this.validationForm(this.$refs.lmFormBuilder.$v, false)
      const formValidation = this.validationForm(this.$v, false)
      await Promise.all([lmFormBuilderValidations, formValidation])
      try {
        this.loading = true
        if (this.isOnEditMode) {
          await commonsApi.axiosPutWrapper(`${this.newOrEditEndpointUri}/${this.$route.params.id}`, this.form)
          this.lmToastSuccessInternalLink(`/obras/visadoparcelario/${this.form.NumeroDocumento}/${this.$route.params.id}`, 'Puede ver el registro aquí', 'Se guardó exitosamente')
          setTimeout(() => {
            this.loading = false
            this.$router.push('/obras/visadoparcelario')
          }, 1500)
        } else {
          const r = await commonsApi.axiosPostWrapper(`${this.newOrEditEndpointUri}/`, this.form)
          this.lmToastSuccessInternalLink(`/obras/visadoparcelario/${this.form.NumeroDocumento}/${r?.data?._id}`, 'Por favor asocie los documentos necesarios.', 'Se guardó exitosamente')
          this.$router.push(`/documentos/decertificadoparcelario/nuevo/${r.data.Tramite}`)
        }
      } catch (error) {
        this.loading = false
        this.showToastFormError()
      }
    },
    async setForm () {
      commonsApi.axiosGetWrapper(`${this.vecinoEndpointUri}${this.$route.params.documento}`)
        .then(resp => {
          if (Array.isArray(resp.data) && resp.data.length) {
            this.vecino = resp.data[0]
            this.form.NumeroDocumento = this.vecino.NumeroDocumento
          }
          this.vecinoIsLoading = false
        })
        .catch(e => {
          this.vecinoIsLoading = false
        })
      if (this.isOnEditMode) {
        await this.activeEditMode({
          path: this.newOrEditEndpointUri,
          id: this.$route.params.id,
          paramsMode: true
        })
      } else {
        this.form = JSON.parse(this.initialForm)
        this.showLoading()
        setTimeout(() => {
          this.$v.$reset()
          this.hideLoading()
        }, 350)
      }
    },
    updateForm (formDataFromLmFormBuilder) {
      for (const key in formDataFromLmFormBuilder) {
        this.form[key] = formDataFromLmFormBuilder[key]
      }
    },
    fileCreated (file, response) {
      if (response) {
        this.files.push(response)
      }
    },
    fileRemoved (file, error, xhr) {
      if (file) {
        this.files = this.files.filter(f => f.originalname !== file.name)
      }
    },
    async search () {
      try {
        this.formIsProcessing = true
        this.propietarioIsLoading = true
        const resp = await commonsApi.axiosGetWrapper(`${this.vecinoEndpointUri}${this.searchPropietarioNumeroDocumento}`)
        if (Array.isArray(resp.data) && resp.data.length) {
          this.innerIsLoading = true
          this.vecinoNoEncontrado = false
          this.propietario = resp.data[0]
          this.form.PropietarioNumeroDocumento = this.propietario?.NumeroDocumento || false
          this.form.PropietarioTipoDocumento = this.propietario?.TipoDocumento || false
        } else {
          this.vecinoNoEncontrado = true
          // this.vecinos = []
        }
      } catch (e) {
        console.log(e)
        this.vecinoNoEncontrado = true
        this.vecinos = []
      } finally {
        this.formIsProcessing = false
        this.propietarioIsLoading = false
      }
    }
  },
  async created () {
    this.isOnEditMode = !!this.$route.params.id
    this.setForm()
    await this.$nextTick()
    for (const key in this.$refs.lmFormBuilder.formObjectToSendToServer) {
      const value = this.$refs.lmFormBuilder.formObjectToSendToServer[key]
      this.$set(this.form, key, value)
    }
  }
}
</script>
<style lang="sass" scoped>
  .search-prop-doc
    margin-top: 2rem !important
</style>
